import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Button, Popover, PopoverBody } from 'reactstrap';

import ChooseModal from './ChooseModal';

interface ChooseModalProps {
  isOpen: boolean;
  onClose: () => void;
  refetchClients: () => void;
  target?: string;
}

const ModalAddSwitch = ({ isOpen, refetchClients, onClose, target = 'add-action-btn' }: ChooseModalProps) => {
  const { t } = useTranslation();
  const [isManageModalOpen, setIsManageModalOpen] = useState(false);
  const [currentTab, setCurrentTab] = useState<'clientCreation' | 'technicianCreation' | 'ownerCreation'>(
    'clientCreation',
  );
  const shouldOpenPopover = isOpen && !isManageModalOpen;
  const renderChooseTab = () => (
    <div className="d-flex flex-column align-items-center justify-content-center gap-2 w-80">
      <Button
        color="secondary"
        style={{ background: 'transparent', minWidth: '70px' }}
        size="sm"
        className="w-30 p-2 border border-success"
        outline
        onClick={() => {
          setIsManageModalOpen(true);

          setCurrentTab('ownerCreation');
        }}
      >
        <div className="text-success">{t('Modals.choose-action.add-client')}</div>
      </Button>
      <Button
        color="secondary"
        size="sm"
        className="w-30 p-2 border border-success"
        style={{ background: 'transparent', minWidth: '70px' }}
        onClick={() => {
          setIsManageModalOpen(true);
          setCurrentTab('technicianCreation');
        }}
      >
        <div className="text-success">{t('Modals.choose-action.add-site')}</div>
      </Button>
    </div>
  );
  return (
    <div>
      {shouldOpenPopover && (
        <Popover placement="bottom-end" isOpen target={target} toggle={onClose} trigger="legacy">
          <PopoverBody className="p-2">{renderChooseTab()}</PopoverBody>
        </Popover>
      )}

      <ChooseModal
        currentTab={currentTab}
        clientId={undefined}
        isOpen={isManageModalOpen}
        onClose={() => setIsManageModalOpen(false)}
        refetchClients={refetchClients}
      />
    </div>
  );
};

export default ModalAddSwitch;
